<template>
    <div
        ref="col"
        class="gz-data__col"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BaseTableDataCol',

    props: {
        state: {
            type: String
        }
    },
    computed: {
        normalizedState() {
            if (this.state) return this.state.trim().toLowerCase()
        }
    },
    mounted() {
        this.setColColor()
    },
    methods: {
        setColColor() {
            if (this.normalizedState === 'новый') this.$refs.col.classList.add('gz-data__col_new')
            if (this.normalizedState === 'подтвержден') this.$refs.col.classList.add('gz-data__col_approved')
            if (this.normalizedState === 'выполняется') this.$refs.col.classList.add('gz-data__col_in-process')
            if (this.normalizedState === 'выполнен') this.$refs.col.classList.add('gz-data__col_done')
            if (this.normalizedState === 'отменен') this.$refs.col.classList.add('gz-data__col_canseled')
            if (this.normalizedState === 'отменен администратором') this.$refs.col.classList.add('gz-data__col_canseled-admin')
        }
    }
}
</script>